import { Shift } from '@nexelem/config';
import { addDays } from 'date-fns';

export const getShiftDateRange = (
  shifts: Shift[],
  selectedShifts: Shift['nameKey'][],
  date: Date,
): { from: Date; to: Date } | null => {
  if (selectedShifts.length === 0) {
    return null;
  }

  const orderedSelected = [...selectedShifts].sort(
    (a, b) => shifts.findIndex((s) => s.nameKey === a) - shifts.findIndex((s) => s.nameKey === b),
  );

  const firstShift = shifts.find((s) => s.nameKey === orderedSelected[0]);
  const lastShift = shifts.find((s) => s.nameKey === orderedSelected[orderedSelected.length - 1]);

  if (!firstShift || !lastShift) {
    return null;
  }

  const dateStr = date.toDateString();

  return {
    from: new Date(`${dateStr} ${firstShift.from}`),
    to: addDays(new Date(`${dateStr} ${lastShift.to}`), lastShift.endNextDay ? 1 : 0),
  };
};
